export default __webpack_public_path__ + "static/media/design_red.png.webp";